import { TAO_KOE, TaoConsole, Cookies } from '../libs';

const Tracking = {};

const readUTMParams = function() {
	const params = new URLSearchParams( window.location.search );

	const utmParams = [
		'UTM_SOURCE',
		'UTM_MEDIUM',
		'UTM_CAMPAIGN',
		'UTM_TERM',
		'UTM_CONTENT',
	];

	for ( const [ key, value ] of params.entries() ) {
		if ( utmParams.includes( key.toUpperCase() ) && value ) {
			Cookies.set( key, value, { secure: true } );
		}
	}
};

const trackVideos = () => {
	const videoEls = Array.from( document.getElementsByTagName( 'video' ) );
	videoEls.forEach( ( videoEl ) => {
		// Set flags for each video.
		let fullSeen = false;
		let halfSeen = false;

		// Add event listener for time tracking.
		videoEl.addEventListener( 'timeupdate', () => {
			const currTime = Math.floor( videoEl.currentTime );
			const fullLength = Math.floor( videoEl.duration );
			const treshold = fullLength / 2;

			if ( currTime >= treshold && ! halfSeen ) {
				TaoConsole.log( '50% erreicht!' );
				window.dataLayer = window.dataLayer || [];
				window.dataLayer.push( {
					event: 'gtmVideoPlay',
				} );

				halfSeen = true;
			} else if ( currTime === fullLength && ! fullSeen ) {
				TaoConsole.log( '100% erreicht!' );
				window.dataLayer = window.dataLayer || [];
				window.dataLayer.push( {
					event: 'gtmVideoEngage',
					gtmVideoPlayheadPosition: '50',
				} );

				fullSeen = true;
			}
		} );
	} );
};

Tracking.initPromoViewTracking = function() {
	const trackedPromos = new Set();
	const maxBatchSize = 32;
	let batchTimeout = null;
	let batchedPromos = [];
	const promoSelector = '.promo_tracking';

	const sendBatch = () => {
		if ( ! batchedPromos.length ) {
			return;
		}

		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push( {
			'event': 'promotionView',
			'ecommerce': {
				'promoView': {
					promotions: batchedPromos,
				},
			},
		} );

		batchedPromos = [];
		batchTimeout = null;
	};

	const scheduleBatch = () => {
		if ( null !== batchTimeout ) {
			return;
		}
		batchTimeout = setTimeout( sendBatch, 1000 ); // Fetch all products in timeframe of 1 second and then send batch
	};

	const observer = new IntersectionObserver( ( entries ) => {
		entries.forEach( ( { target: promoEl, isIntersecting } ) => {
			if ( ! isIntersecting ) {
				return;
			}

			const promoId = promoEl.dataset.gtmid;
			if ( ! promoId ) {
				return;
			}

			if ( trackedPromos.has( promoId ) ) {
				return;
			}

			trackedPromos.add( promoId );
			batchedPromos.push( {
				id: promoEl.dataset.gtmid,
				name: promoEl.dataset.gtmname || promoEl.dataset.gtmid,
			} );

			scheduleBatch();
			if ( batchedPromos.length >= maxBatchSize ) {
				sendBatch();
			}
		} );
	}, { threshold: 0.5 } );

	const observeNewPromos = () => {
		document.querySelectorAll( promoSelector ).forEach( ( promoEl ) => {
			if ( ! trackedPromos.has( promoEl.dataset.eecId ) ) {
				observer.observe( promoEl );
			}
		} );
	};

	// Oberserve initial promos
	observeNewPromos();

	// Observe dynamically added promos
	const mutationObserver = new MutationObserver( ( mutations ) => {
		mutations.forEach( ( mutation ) => {
			mutation.addedNodes.forEach( ( node ) => {
				// Check for product directly or in nested dom
				if ( 1 === node.nodeType && ( node.matches( promoSelector ) || node.querySelector( promoSelector ) ) ) {
					observeNewPromos();
				}
			} );
		} );
	} );

	mutationObserver.observe( document.body, { childList: true, subtree: true } );
};

Tracking.initPromoClickTracking = function() {
	document.addEventListener( 'click', function( ev ) {
		const buttonEl = ev.target.closest( '.promo_tracking' );
		if ( buttonEl ) {
			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push( {
				'event': 'promotionClick',
				'ecommerce': {
					'promoClick': {
						'promotions': [ {
							'id': buttonEl.dataset.gtmid,
							'name': buttonEl.dataset.gtmname || buttonEl.dataset.gtmid,
						} ],
					},
				},
			} );
		}
	} );
};

Tracking.init = function() {
	Tracking.initPromoViewTracking();
	Tracking.initPromoClickTracking();

	trackVideos();
	readUTMParams();
};

Tracking.sendIdentifyEvent = ( spec, email, event ) => {
	const DYO = window.DYO;
	const dataLayer = window.dataLayer = window.dataLayer || [];
	const updatedMail = null !== email && undefined !== email && 'function' === typeof DYO?.dyhash?.sha256 ? DYO.dyhash.sha256( email.toLowerCase() ) : 'undefined';
	let updatedEvent;

	switch ( event ) {
		case 'Friend Invite':
		case 'Geschenkkarte':
		case 'Pluscard':
			updatedEvent = event;
			break;
		default:
			updatedEvent = spec + ' ' + event;
	}

	dataLayer.push( {
		event: 'gtmIdentification ' + spec,
		gtmEmailSHA256: updatedMail,
		gtmIdentifySpec: spec,
		gtmEventString: updatedEvent,
	} );
};

Tracking.saveSiteHash = () => {
	const hash = window.location.hash;
	const siteHash = hash.substring( 1, hash.length );
	sessionStorage.setItem( 'sitehash', siteHash );
};

// Init.
TAO_KOE.ready( 'tracking.js', Tracking.init );

// Expose.
TAO_KOE.Tracking = Tracking;
export default Tracking;
